<template>
  <base-section id="vision">
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="7"
        >
          <h2 class="hh-h2 mb-6">
            Explore AI in every direction, and bring the efficiency home.
          </h2>
          <div class="hh-vision__body">
            <p>
              Our vision is to explore AI in different ways. Agents, video, games, social platforms:
              we try things, keep what works, and let the rest go.
            </p>
            <p>
              This is a fast-changing industry. What was state of the art in the spring is a commodity by the fall.
              We are here to adapt: to learn the new tools as they arrive and to rebuild when the ground moves.
            </p>
            <p>
              The point of all of it is efficiency. Every hour a tool gives back is an hour someone spends on their family,
              their craft, or a night out with friends. VividMotion turns a sentence into a finished reel.
              Total Chaos turns any room into a party. Both exist to give people more of the good part.
            </p>
            <p class="hh-vision__line">
              Our vision is to help bring efficiency to the world so people can enjoy more.
            </p>
          </div>
        </v-col>

        <v-col
          cols="12"
          md="4"
          offset-md="1"
        >
          <div class="hh-vision__beliefs">
            <div
              v-for="belief in beliefs"
              :key="belief.title"
              class="hh-vision__belief"
            >
              <div class="hh-vision__belief-title">
                {{ belief.title }}
              </div>
              <p class="hh-muted mb-0">
                {{ belief.text }}
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionVision',

    data: () => ({
      beliefs: [
        {
          title: 'Explore',
          text: 'We build with AI in many forms and follow what turns out to be useful, not what was planned.',
        },
        {
          title: 'Adapt',
          text: 'The models and tools change every few months. We change with them instead of defending old choices.',
        },
        {
          title: 'Efficiency for people',
          text: 'The goal of every product is to hand time back to the person using it.',
        },
        {
          title: 'Enjoy more',
          text: 'Time saved should go toward the things worth doing. That is the whole point.',
        },
      ],
    }),
  }
</script>

<style lang="sass">
  .hh-vision
    &__body
      font-size: 1.1rem
      line-height: 1.7
      max-width: 38em

      p
        margin-bottom: 1.2em

    &__line
      font-family: var(--hh-font-display)
      font-weight: 500
      font-size: 1.45rem
      line-height: 1.4
      color: var(--hh-text)

    &__beliefs
      display: grid
      gap: 20px
      position: relative
      padding-left: 22px

      &::before
        content: ''
        position: absolute
        left: 0
        top: 0
        bottom: 0
        width: 3px
        border-radius: 2px
        background: var(--hh-spectrum-v)

    &__belief-title
      font-weight: 600
      margin-bottom: 4px
</style>
